module.exports = __webpack_public_path__ + "img/In_Love.d6dc36a2.png";